import {useEffect, useRef} from 'react'
import axios from 'axios'
import {useAuth} from '@clerk/react'
import {setupAxios} from '../app/modules/auth/core/AuthHelpers'

export function AxiosProvider({children}: any) {
  const {getToken} = useAuth()
  const getTokenRef = useRef(getToken)

  useEffect(() => {
    getTokenRef.current = getToken
  }, [getToken])

  useEffect(() => {
    const eject = setupAxios(axios, () => getTokenRef.current())
    return eject
  }, [])

  return children
}
